import styled from 'styled-components';
import Theme from '../../styles/models/theme';
import CommonBtn from '../../components/atoms/Buttons/CommonBtn';
import {theme} from '../../styles/darkTheme';

export const Container = styled.div<{theme: Theme}>`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({theme}) => theme.background};
  text-align: center;
`;

export const LogoContainer = styled.div`
  padding-top: 20px;
  margin-bottom: 40px;
`;

export const TitleContainer = styled.div`
  margin-bottom: 40px;
`;

export const Title = styled.text<{
  theme: Theme;
}>`
  padding-top: 200px;
  font-weight: bold;
  font-size: 26px;
  color: ${({theme}) => theme.lightText};
`;

export const BottomContainer = styled.div<{theme: Theme}>`
  height: 100%;
  background-color: ${({theme}) => theme.lightBackground};
  padding: 40px 23px 10px 23px;
  text-align: center;
`;

export const TextContainer = styled.div`
  text-align: left;
  margin-bottom: 10px;
`;

export const Text = styled.text<{
  theme: Theme;
  bold?: boolean;
  opacity?: number;
}>`
  font-weight: ${({bold}) => (bold ? 'bold' : 'normal')};
  font-size: 18px;
  color: ${({theme}) => theme.darkText};
  line-height: 30px;
  opacity: ${({opacity}) => (opacity ? opacity : 1)};
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const DataContainer = styled.div<{theme: Theme}>`
  text-align: left;
  padding: 10px;
  background-color: ${({theme}) => theme.white};
  display: flex;
  flex-direction: column;
`;

export const ButtonContainer = styled.div`
  text-align: center;
`;

export const Button = styled(CommonBtn)<{theme: Theme; back?: boolean}>`
  width: 100%;
  background-color: ${({back}) => (back ? theme.lightBackground : null)};
  margin-top: 10px;
  margin-bottom: 10px;
`;
